// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csPGyUwHwfAckSGLGZ_c {
  position: relative;
}

.HK2c1lJ4rBJ1g4IVHmaB {
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.kxcu3wAFpWj60cqIklTU {
  cursor: not-allowed;
  opacity: 0.4;
}

.kjrGY4OsD0hsTgcZnL04:not(:last-child) {
    margin-bottom: 1rem;
  }

.w9mS3Me_FlQZeZmKHiGn {
  color: var(--primary-link-color);
}

.Y6U7yAaFisHNPdv9X6NA {
  position: absolute;
  top: calc(100% + 1rem);
  right: 0;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  border-radius: 0.5rem;
  background-color: var(--grey-100);
  box-shadow: 0 0.25rem 0.75rem var(--black-012);
}

.WkoskiMD5tkSe4HduEkc {
  color: var(--secondary-link-color);
}

.FEZ5DMm0RMIt2169ry4k {
  color: var(--header-text-color-v2);
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .WkoskiMD5tkSe4HduEkc {
    font-size: 0.625rem;
    line-height: 0.875rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .WkoskiMD5tkSe4HduEkc {
    font-size: 0.625rem;
    line-height: 0.875rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AccountNavigation/AccountNavigation.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAGE;IACE,mBAAmB;EACrB;;AAGF;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,eAAa;EACb,qBAAkB;EAClB,iCAAiC;EACjC,8CAAuC;AACzC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;EACE;IACE,mBAAe;IACf,qBAAiB;EACnB;AACF;;AAEA;;EACE;IACE,mBAAe;IACf,qBAAiB;EACnB;AACF","sourcesContent":[".navigation {\n  position: relative;\n}\n\n.link {\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n}\n\n.linkDisabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n\n.navigationLink {\n  &:not(:last-child) {\n    margin-bottom: 16px;\n  }\n}\n\n.textActive {\n  color: var(--primary-link-color);\n}\n\n.dropdown {\n  position: absolute;\n  top: calc(100% + 16px);\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n  border-radius: 8px;\n  background-color: var(--grey-100);\n  box-shadow: 0 4px 12px var(--black-012);\n}\n\n.iconsLabels {\n  color: var(--secondary-link-color);\n}\n\n.headerV2IconLabels {\n  color: var(--header-text-color-v2);\n}\n\n@media (--tablet) {\n  .iconsLabels {\n    font-size: 10px;\n    line-height: 14px;\n  }\n}\n\n@media (--mobile) {\n  .iconsLabels {\n    font-size: 10px;\n    line-height: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigation": `csPGyUwHwfAckSGLGZ_c`,
	"link": `HK2c1lJ4rBJ1g4IVHmaB`,
	"linkDisabled": `kxcu3wAFpWj60cqIklTU`,
	"navigationLink": `kjrGY4OsD0hsTgcZnL04`,
	"textActive": `w9mS3Me_FlQZeZmKHiGn`,
	"dropdown": `Y6U7yAaFisHNPdv9X6NA`,
	"iconsLabels": `WkoskiMD5tkSe4HduEkc`,
	"headerV2IconLabels": `FEZ5DMm0RMIt2169ry4k`
};
export default ___CSS_LOADER_EXPORT___;
